    export default class LayoutNavigationHelper {
        static layoutHasContent(layout) {
            if (layout.getElementsByClassName('has-submenu').length > 0 && layout.querySelectorAll('.has-submenu .js-hide-navigation-arrow').length == 0) {
                return true;
            }

            var dropdown = layout.getElementsByClassName('navDropdown')[0];

            return !!dropdown && !!dropdown.childNodes && dropdown.childNodes.length > 0 && dropdown.querySelector('a');
        }

        static sublayoutHasContent(layout) {
            var dropdown = layout.getElementsByClassName('navLevelTwoDropdown')[0];

            return !!dropdown && !!dropdown.childNodes && dropdown.childNodes.length > 0;

        }

        static async getNavigationData(navigationElement) {
            if (!navigationElement) {
                return;
            }

            return await fetch(navigationElement.getAttribute('data-fetch-url'))
                .then(function (response) {
                    return response.text();
                })
                .then(function (response) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(response, 'text/html');
                    const navWrapper = doc.getElementsByClassName('navWrapper')[0];
                    return navWrapper.innerHTML;
                })
                .catch(function (response) {
                    console.log(response.statusText);
                });
        }
    }